module.exports = __webpack_public_path__ + "static/media/LA.bc15db06.png";